import { render, staticRenderFns } from "./jiaoxue.vue?vue&type=template&id=3f27406e&scoped=true"
import script from "./jiaoxue.vue?vue&type=script&lang=ts"
export * from "./jiaoxue.vue?vue&type=script&lang=ts"
import style0 from "./jiaoxue.vue?vue&type=style&index=0&id=3f27406e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f27406e",
  null
  
)

export default component.exports